import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function UpgradePrompt({ featureName, currentTier, onClose }) {
  const navigate = useNavigate();

  const getFeatureDescription = (feature) => {
    const descriptions = {
      'connect': 'Connect with other horse owners, share information, and stay in touch',
      'memberships': 'Manage your association memberships and track renewals',
      'veterinarians': 'Store and manage veterinarian contact information',
      'family_plan': 'Add family members to your account for shared access',
      'export_data': 'Export your horse and health data for backup or analysis',
      'advanced_analytics': 'Get detailed insights and reports about your horses',
      'rodeos': 'Manage events and capture memories with photos and videos',
      'horse_breedings': 'Track breeding cycles and foaling dates',
      'horse_deworming': 'Manage deworming schedules and treatments',
      'horse_medical_history': 'Comprehensive medical history tracking'
    };
    return descriptions[feature] || 'This feature is not available with your current plan';
  };

  const getUpgradeTier = (feature) => {
    const tierMap = {
      'connect': 'Enhanced',
      'memberships': 'Enhanced',
      'veterinarians': 'Enhanced',
      'family_plan': 'Enhanced',
      'export_data': 'Enhanced',
      'advanced_analytics': 'Premium',
      'rodeos': 'Premium',
      'horse_breedings': 'Enhanced',
      'horse_deworming': 'Enhanced',
      'horse_medical_history': 'Premium'
    };
    return tierMap[feature] || 'Enhanced';
  };

  const handleUpgrade = () => {
    navigate('/subscription');
    if (onClose) onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[70]">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
            <svg className="h-6 w-6 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Feature Not Available
          </h3>
          
          <p className="text-sm text-gray-600 mb-4">
            {getFeatureDescription(featureName)}
          </p>
          
          <div className="bg-blue-50 rounded-lg p-4 mb-4">
            <p className="text-sm text-blue-800">
              <span className="font-medium">Current Plan:</span> {currentTier || 'None'}
            </p>
            <p className="text-sm text-blue-800">
              <span className="font-medium">Upgrade to:</span> {getUpgradeTier(featureName)} Plan
            </p>
          </div>
          
          <div className="flex space-x-3">
            <button
              onClick={handleUpgrade}
              className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
            >
              Upgrade Now
            </button>
            <button
              onClick={onClose}
              className="flex-1 bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400 transition-colors"
            >
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
} 